import {Grid} from 'src/design/atoms/Grid';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import {UserStatusEnum} from 'src/api/ProactApiClient';
import {PendingAccountSetup} from 'src/pages/Dashboard/Landing/components/PendingAccountSetup/PendingAccountSetup';
import {useAppSelector} from 'src/redux/hooks';
import {MyCoursesCard} from '../MyCoursesCard/MyCoursesCard';
import {MySkillsCard} from '../MySkills/MySkillsCard';
import {SkillRequestsCard} from '../MySkills/SkillRequestsCard';

// This view already lives behind TrainingDash.page's `ContentWrapper
// featureFlag={FeatureFlagEnum.Training}` — no second feature-flag check
// needed here.
const ListUserTrainings: React.FC = () => {
  const {session} = useAppSelector(state => state.session);
  const userStatus = session?.userStatus;
  const isPending = userStatus === UserStatusEnum.Pending;

  return (
    <Stack gap="lg">
      {isPending && <PendingAccountSetup />}
      <Grid gutter="lg">
        <Grid.Col span={{base: 12, lg: 8, xl: 9}}>
          <Stack gap="lg">
            <MyCoursesCard />
            {!isPending && <SkillRequestsCard />}
          </Stack>
        </Grid.Col>
        <Grid.Col span={{base: 12, lg: 4, xl: 3}}>
          <MySkillsCard />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default ListUserTrainings;
